export const vacancyStatus = Object.freeze({
  DRAFT: 'draft',
  ACTIVE: 'active',
  ARCHIVE: 'archive',
});

export const invitationType = Object.freeze({
  ONLINE_INTERVIEW: 'virtual_interview',
  OFFICE_INTERVIEW: 'office_interview',
});

export const interviewType = Object.freeze({
  ONLINE_INTERVIEW: 'virtual_interview',
  OFFICE_INTERVIEW: 'office_interview',
});

export const candidateStatus = Object.freeze({
  IMPORTED: 'imported',
  INVITED: 'invited',
  INTERVIEWED: 'interviewed',
  INOFFICE_INTERVIEW: 'inoffice_interview',
  JOB_OFFER: 'job_offer',
  HIRED: 'hired',
  DECLINED: 'declined',
  TESTED: 'tested',
});

export const candidateLogType = Object.freeze({
  COMMENT: 'comment',
  INVITED: 'invited',
  SELF_INVITED: 'self_invited',
  INTERVIEWED: 'interviewed',
  INOFFICE_INTERVIEW: 'inoffice_interview',
  JOB_OFFER: 'job_offer',
  HIRED: 'hired',
  DECLINED: 'declined',
  DECLINED_REASON: 'declined_reason',
  REFUSED: 'refused',
  COVER_LETTER: 'cover_letter',
  OFFICE_INTERVIEW_PASSED: 'office_interview_passed',
  MESSAGE_SENT: 'message_sent',
  FOLLOWING_INVITE_LINK: 'following_invite_link',
  ONLINE_INTERVIEW_RECORDING_STARTED: 'online_interview_recording_started',
  ONLINE_INTERVIEW_PROCESSING_FAILED: 'online_interview_processing_failed',
  OFFICE_INTERVIEW_PROCESSING_FAILED: 'office_interview_processing_failed',
  IMPORTED: 'imported',
  STATUS_CHANGED: 'status_changed',
  AI_INTERVIEW_REVIEW_READY: 'ai_interview_review_ready',
  AI_PROCESSING_READY: 'ai_processing_ready',
  INTERVIEW_TRANSCRIPTION_READY: 'interview_transcription_ready',
  TEST_STARTED: 'test_started',
  TEST_FINISHED: 'test_finished',
  CANDIDATE_ADDITIONAL_FIELDS: 'candidate_additional_fields',
  TESTED: 'tested',
  CANDIDATE_SENT_MESSAGE: 'candidate_sent_message',
});

export const interviewStatusType = Object.freeze({
  BLANK: 'blank',
  RECORDING: 'recording',
  COMPLETE: 'complete',
  PROCESSING: 'processing',
  READY: 'ready',
  PROCESSING_FAILED: 'processing_failed',
});

export const questionTypes = Object.freeze({
  TEXT: 'text_question',
  VIDEO: 'video_question',
});

export const interviewPresetTypes = Object.freeze({
  COMMON: 'common',
  PROFESSION: 'profession',
});

export const logType = Object.freeze({
  CANDIDATE: 'candidate',
  OFFICE_INTERVIEW: 'office_interview',
  ONLINE_INTERVIEW: 'online_interview',
});

export const resourceType = Object.freeze({
  REDIRECT: 'redirect',
});

export const localeType = Object.freeze({
  EN: 'en',
  RU: 'ru',
  UK: 'ru', // Ukrainian
  BE: 'ru', // Belarusian
  KK: 'ru', // Kazakh
  DEFAULT: 'en',
});

export const notificationChannelType = Object.freeze({
  EMAIL: 'email',
  SMS: 'sms',
});

export const notificationType = Object.freeze({
  CANDIDATE_COMMON: 'candidate_common',
  CANDIDATE_INOFFICE_INTERVIEW: 'candidate_inoffice_interview',
  CANDIDATE_JOB_OFFER: 'candidate_job_offer',
  CANDIDATE_DECLINED: 'candidate_declined',
  CANDIDATE_SHARE_LINK: 'candidate_share_link',
});

export const chromeExtensionMessageTypes = Object.freeze({
  GET_VERSION: 'get-version',
});

export const candidatePhotoType = Object.freeze({
  W300: 'w300',
  S50: 's50',
});

export const interviewImageType = Object.freeze({
  H296: 'h296',
});

export const questionCategoryType = Object.freeze({
  COMMON: 'common',
  SPECIAL: 'special',
});

export const wizardSteps = Object.freeze({
  STORE: 'store',
  PRESET: 'preset',
  TESTING: 'testing',
  COMMON: 'common',
  CATEGORY: 'category',
  SPECIAL: 'special',
  QUESTIONS: 'questions',
  AI_QUESTIONS: 'ai_questions',
  INTEGRATION: 'integration',
  FAQ: 'faq',
  PUBLISH: 'publish',
});

/**
 * Enum for candidateNotificationTypes values.
 * @readonly
 * @enum {string}
 */
export const candidateNotificationTypes = Object.freeze({
  EMAIL: 'Email',
  EMAIL_AND_WHATSAPP: 'EmailAndWhatsapp',
  EMAIL_AND_SMS: 'EmailAndSMS',
  EMAIL_AND_CALL: 'EmailAndCall',
  SMS: 'sms',
  CALL: 'call',
});

export const candidatesInviteTypes = Object.freeze({
  ALL: 'all',
  SELF: 'self',
});

export const vacancyVisibility = Object.freeze({
  INVITATION: 'invitation',
  ALL: 'all',
});

export const appLayouts = Object.freeze({
  DEFAULT: 'DefaultLayout',
  INTEGRATIONS: 'IntegrationsLayout',
  INVITE: 'InviteLayout',
});

export const integrationsErrorType = Object.freeze({
  UNEXPECTED_BEHAVIOR: 'unexpected_behavior',
  AUTHENTICATION_REQUIRED: 'authentication_required',
  ADMIN_AUTH_REQUIRED: 'admin_auth_required',
});

export const settingsEntityType = Object.freeze({
  COMPANY: 'company',
  VACANCY: 'vacancy',
});

export const settingsTabs = Object.freeze({
  INTEGRATIONS: 'integrations',
  PAYMENT: 'payment',
  ACCOUNT: 'account',
  TEMPLATES: 'templates',
  USERS: 'users',
});

export const accountTabs = Object.freeze({
  INFO: 'info',
  SETTINGS: 'settings',
});

export const notificationTemplatesTabs = Object.freeze({
  MAIL_TEMPLATES: 'mail_templates',
  EDITOR: 'editor',
});

export const portalTabs = Object.freeze({
  START: 'start',
  DESIGN: 'design',
  ARTICLES: 'articles',
  SETTINGS: 'settings',
});

export const payTypes = Object.freeze({
  NET: 'net',
  GROSS: 'gross',
});

export const payFrequencies = Object.freeze({
  YEAR: 'year',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  HOUR: 'hour',
});

export const paymentDrivers = Object.freeze({
  STRIPE: 'stripe',
  ROBOKASSA: 'robokassa',
  ALFABANK: 'alfabank',
});

export const paymentTabs = Object.freeze({
  PLAN: 'plan',
  PLANS: 'plans',
  HISTORY: 'history',
  INFO: 'info',
  TRANSACTIONS: 'transactions',
  PAYMENTS: 'payments',
  LOYALTY: 'loyalty',
  TRIAL: 'trial',
});

export const paymentTypes = Object.freeze({
  FIRST: 'first',
  UPGRADE: 'upgrade',
});

export const quotaTypes = Object.freeze({
  PERMANENT: 'permanent',
  TEMP: 'temp',
});

export const quotaItemTypes = Object.freeze({
  INTERVIEWS: 'interviews',
  SMS: 'sms',
  CALLS: 'calls',
});

export const orderPlanOperations = Object.freeze({
  UPGRADE: 'upgrade',
  DOWNGRADE: 'downgrade',
  RENEW: 'renew',
  PROLONG: 'prolong',
});

export const orderTypes = Object.freeze({
  PLAN: 'plan',
});

export const vacancyListFilterType = Object.freeze({
  ACTIVE: 'all',
  ADDRESS: 'address',
  LIST: 'list',
});

export const vacancyTemplateTypes = Object.freeze({
  SCRATCH: 'scratch',
  EXPRESS: 'express',
});

export const candidateInvitationType = Object.freeze({
  SHAREABLE: 'shareable',
  PERSONAL: 'personal',
  EXCEL: 'excel',
});

export const candidateInterviewType = Object.freeze({
  ONLINE_INTERVIEW: 'online_interview',
  OFFICE_INTERVIEW: 'office_interview',
  VIDEO_CALL: 'video_call',
  UPLOADED_VIDEO: 'uploaded_video',
});

export const createUploadedVideoType = Object.freeze({
  FILE: 'file',
  LINK: 'link',
});

export const companyPartnerCodeType = Object.freeze({
  ROSTELECOM: 'RT',
});

export const companyTabs = Object.freeze({
  COMPANY: 'company',
  CAREER_PORTAL: 'career_portal',
});

export const groupKanbanOperations = Object.freeze({
  MOVE: 'move',
  SEND_EMAIL: 'send_email',
  SEND_SMS: 'send_sms',
  REJECT: 'reject',
});

export const articleStatuses = Object.freeze({
  PUBLISHED: 'published',
  DRAFT: 'draft',
});

export const testQuestionTypes = Object.freeze({
  SELECT: 'select',
  MULTISELECT: 'multiselect',
  TEXT: 'text',
  FREE: 'free',
  NUMERIC: 'numeric',
});

export const testTypes = Object.freeze({
  NOT_REQUIRED: 'not_required',
  EXPLANATION: 'explanation',
  CUTOFF: 'cutoff',
});

export const testEstimationTypes = Object.freeze({
  PERCENT: 'percent',
});

export const qrBannerTypes = Object.freeze({
  SQUARE: 'square',
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
});

export const addFieldTypes = Object.freeze({
  STRING: 'string',
  INTEGER: 'integer',
  SELECT: 'select',
  DATE: 'date',
});

export const timestampTypes = Object.freeze({
  LISTENING: 'listening',
  ANSWERING: 'answering',
});
